/* One framed stage, wider than the text column like the testimonial rail. */
.stage {
  position: relative;
  isolation: isolate;
  width: min(96vw, 140rem);
  margin-inline: calc(50% - min(48vw, 70rem));
  overflow: hidden;
  border-radius: var(--radius-lg);
  background: var(--surface-dark);
}

/* ---- backdrops: every study's render stacked, the active one faded in ---- */
.backdrops {
  position: absolute;
  inset: 0;
  z-index: -2;
}
/* Two classes: Picture's own `.picture` sets an opaque fill that would hide the layers below. */
.backdrops .backdrop {
  position: absolute;
  inset: 0;
  height: 100%;
  background: none;
}
.backdrops img {
  opacity: 0;
  transform: scale(1.03);
  transition:
    opacity 700ms var(--ease),
    transform 1400ms var(--ease);
}
.backdrops .backdropActive {
  opacity: 1;
  transform: none;
}
.scrim {
  position: absolute;
  inset: 0;
  z-index: -1;
  background:
    linear-gradient(90deg, rgba(8, 13, 19, 0.88) 0%, rgba(8, 13, 19, 0.45) 45%, transparent 75%),
    linear-gradient(0deg, rgba(8, 13, 19, 0.7) 0%, transparent 45%),
    linear-gradient(180deg, rgba(8, 13, 19, 0.55) 0%, transparent 25%);
}

/* ---- tabs ---------------------------------------------------------------- */
.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  padding: var(--sp-6) var(--sp-6) 0;
}
.tab {
  padding: 0.55rem 1.15rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 999px;
  background: rgba(8, 13, 19, 0.45);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  color: var(--text-on-dark);
  font-family: var(--font-display);
  font-size: var(--fs-sm);
  font-weight: 600;
  white-space: nowrap;
  transition:
    background-color var(--dur) var(--ease),
    border-color var(--dur) var(--ease),
    color var(--dur) var(--ease);
}
.tab:hover {
  border-color: rgba(255, 255, 255, 0.7);
}
.tab[aria-selected="true"] {
  border-color: var(--accent);
  background: var(--accent);
  color: var(--text-on-accent);
}

/* ---- panel + card -------------------------------------------------------- */
.panel {
  display: flex;
  align-items: flex-end;
  min-height: clamp(28rem, 62vh, 40rem);
  padding: var(--sp-6);
}
.inlineImage {
  display: none;
}
.card {
  display: grid;
  gap: var(--sp-2);
  max-width: 32rem;
  padding: clamp(var(--sp-6), 2.5vw, var(--sp-10));
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--radius-lg);
  background: rgba(8, 13, 19, 0.7);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  color: var(--text-on-dark-muted);
}
.result {
  margin: 0 0 var(--sp-4);
}
.highlight {
  display: block;
  font-family: var(--font-display);
  font-size: clamp(2.75rem, 1.4rem + 3.2vw, 4.75rem);
  font-weight: 700;
  line-height: 1;
  letter-spacing: var(--tracking-display);
  color: var(--text-on-dark);
}
.highlightText {
  display: block;
  margin-top: var(--sp-3);
  max-width: 26rem;
  font-size: var(--fs-md);
  line-height: var(--lh-snug);
}
.title {
  font-size: var(--fs-xl);
  color: var(--text-on-dark);
}
.client {
  margin: 0;
  font-size: var(--fs-sm);
}
.cta {
  justify-self: start;
  margin-top: var(--sp-4);
}

/* ---- phones: a plain stacked card; text over a busy render doesn't read at 390px ---- */
@media (max-width: 47.99rem) {
  .stage {
    width: auto;
    margin-inline: 0;
    overflow: visible;
    border-radius: 0;
    background: none;
  }
  .backdrops,
  .scrim {
    display: none;
  }
  .tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 0 0 var(--sp-4);
    scrollbar-width: none;
  }
  .tab {
    border-color: var(--border-strong);
    background: var(--surface-raised);
    backdrop-filter: none;
    color: var(--text-strong);
  }
  .panel {
    display: block;
    min-height: 0;
    padding: 0;
  }
  .inlineImage {
    display: block;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  }
  .card {
    max-width: none;
    border: 1px solid var(--border);
    border-top: 0;
    border-radius: 0 0 var(--radius-lg) var(--radius-lg);
    background: var(--surface-raised);
    backdrop-filter: none;
    color: var(--text);
  }
  .highlight,
  .title {
    color: var(--text-strong);
  }
}
